import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelCheckbox as _vModelCheckbox, normalizeClass as _normalizeClass, withDirectives as _withDirectives, unref as _unref, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "form-check-box" }
const _hoisted_2 = ["for"]
const _hoisted_3 = { class: "form-check-box-control" }
const _hoisted_4 = ["disabled", "required", "name"]

import { computed } from 'vue'

import { formatBoolean } from '../../utils/format'


export default /*@__PURE__*/_defineComponent({
  __name: 'FormCheckBox',
  props: {
  modelValue: {
    type: String,
    required: true,
  },

  name: {
    type: String,
    default: null,
  },

  label: {
    type: String,
    default: null,
  },

  errorLabel: {
    type: [Array, String],
    default: null,
  },

  isDisabled: {
    type: Boolean,
    default: false,
  },

  isRequired: {
    type: Boolean,
    default: false,
  },
},
  emits: ['update:modelValue'],
  setup(__props, { emit: __emit }) {

const emit = __emit

const props = __props

const value = computed<string>({
  get: (): string => props.modelValue as string,
  set: (val: string): void => emit('update:modelValue', val),
})

const errorLabelList = computed<Array<string>>(() =>
  Array.isArray(props.errorLabel) ? props.errorLabel : [props.errorLabel],
)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (__props.label)
      ? (_openBlock(), _createElementBlock("label", {
          key: 0,
          for: __props.name
        }, [
          _createTextVNode(_toDisplayString(__props.label), 1),
          _cache[1] || (_cache[1] = _createElementVNode("span", null, ":", -1))
        ], 8, _hoisted_2))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      _withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((value).value = $event)),
        class: _normalizeClass({ 'has-error': Boolean(__props.errorLabel) }),
        disabled: __props.isDisabled,
        required: __props.isRequired,
        name: __props.name,
        type: "checkbox"
      }, null, 10, _hoisted_4), [
        [
          _vModelCheckbox,
          value.value,
          void 0,
          { trim: true }
        ]
      ]),
      _createTextVNode(" " + _toDisplayString(_unref(formatBoolean)(!!value.value)), 1)
    ]),
    (__props.errorLabel)
      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(errorLabelList.value, (error, index) => {
          return (_openBlock(), _createElementBlock("small", {
            key: `error-label-${index}`,
            class: "error-label"
          }, _toDisplayString(error), 1))
        }), 128))
      : _createCommentVNode("", true)
  ]))
}
}

})